var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#41D8CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67373 10.4987C4.69373 10.5782 5.19284 12.4449 8.0004 12.4449C10.8084 12.4449 11.3071 10.5782 11.3271 10.4987C11.3515 10.4022 11.308 10.3022 11.2217 10.2524C11.1351 10.2031 11.0266 10.2178 10.9551 10.2867C10.9466 10.2951 10.0866 11.1115 8.0004 11.1115C5.91418 11.1115 5.05373 10.2951 5.04573 10.2871C5.00307 10.2449 4.94618 10.2227 4.88929 10.2227C4.85195 10.2227 4.81418 10.232 4.77995 10.2511C4.69284 10.3009 4.64929 10.4018 4.67373 10.4987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33279 7.55545C5.94644 7.55545 6.4439 6.859 6.4439 5.99989C6.4439 5.14078 5.94644 4.44434 5.33279 4.44434C4.71914 4.44434 4.22168 5.14078 4.22168 5.99989C4.22168 6.859 4.71914 7.55545 5.33279 7.55545Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6678 7.55545C11.2814 7.55545 11.7789 6.859 11.7789 5.99989C11.7789 5.14078 11.2814 4.44434 10.6678 4.44434C10.0541 4.44434 9.55664 5.14078 9.55664 5.99989C9.55664 6.859 10.0541 7.55545 10.6678 7.55545Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmoji);
export default __webpack_public_path__ + "static/media/happy-emoji.f25a72d7cebc0378c6e83c0c45114610.svg";
export { ForwardRef as ReactComponent };